import { render, staticRenderFns } from "./TheAboutView.vue?vue&type=template&id=11865cb1"
import script from "./TheAboutView.vue?vue&type=script&lang=js"
export * from "./TheAboutView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports